import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {articlesEdit_template} from "../components/templates/articlesEdit_template";
import {articlesView_template} from "../components/templates/articlesView_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class articles_edit extends vnModule_knockoutJS{

    public articlesEdit: articlesEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(): string{

        return "articles_Edit";
    }

    buildContent(): Array<Element>{

        this.articlesEdit = new articlesEdit_template("edit_template", this.viewModel, this);

        this.articlesEdit.setCanSearchUsers(true)

        return [this.articlesEdit.build()];
    }

    public fillPage(): void{

        this.getArticleReferences();
        this.editArticleData();
        this.getPaymentCategories();
        this.articlesEdit.buildDatePickerCalendar();
    }

    protected getArticleReferences(){

        // LOADING : starts
        this.loadingIn(this.articlesEdit.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/references';
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.articlesView.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferenceRequestReturn;
        this.XHRHdl.execute();
    }

    protected onReferenceRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                obj.articlesEdit.setPublishStatuses(responseParsed.publishStatuses);
            });

            obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
    }

    protected getPaymentCategories(){

        let usrReq_url: string;

        usrReq_url = '/api/brand/'+ this.getVnAppZone().app.params.idBrand + '/transaction/rate-categories/get';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetPaymentCategoriesRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onGetPaymentCategoriesRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updatePaymentCategoryList(responseParsed.data);
            });

            obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
    }

    protected updatePaymentCategoryList(responseParsed: any){

        let paymentCategories = [];
        paymentCategories.push({id: null, name: "Select an Option"})
        for (let item of responseParsed.paymentCategories){
            paymentCategories.push(item)
        }

        this.viewModel.edit_template.paymentCategoryFilter.setOptions(paymentCategories);
    }

    protected editArticleData(){

        this.loadingIn(this.articlesEdit.builtTemplate);
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/get/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        //usrReq_params.push(["data", ko.toJSON(this.articlesEdit.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                let allowEditPermalinkBrands = [21,22];
                if(allowEditPermalinkBrands.indexOf(responseParsed.data.idBrand) != -1){
                    obj.articlesEdit.setAllowEditPermalink(true);
                }
                obj.setArticleData(responseParsed.data.article);
            });

            obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
    }

    public setArticleData(article_data: Array<{}>): void{

        this.articlesEdit.setId(article_data['id']);
        this.articlesEdit.setTitle(article_data['title']);
        this.articlesEdit.setReference(article_data['reference']);
        this.articlesEdit.setEditor(
            article_data['editor'] ? article_data['editor']['valnet_user']['fullName']: ""
        );
        this.articlesEdit.setDatePublished(article_data['dateOriginalPublish']);
        this.articlesEdit.setAuthor(
            article_data['author'] ? article_data['author']['valnet_user']['fullName']: ""
        );
        this.articlesEdit.setJrEditor(
            article_data['juniorEditor'] ? article_data['juniorEditor']['valnet_user']['fullName']: ""
        );
        this.articlesEdit.setDisplayAuthor(
            article_data['displayAuthor'] ? article_data['displayAuthor']: ""
        );
        this.articlesEdit.setTargetAudience(
            article_data['targetAudience'] ? article_data['targetAudience']['name']: ""
        );
        this.articlesEdit.setIntent(
            article_data['intent'] ? article_data['intent']['name']: ""
        );
        this.articlesEdit.setContentType(
            article_data['contentType'] ? article_data['contentType']['name']: ""
        );
        this.articlesEdit.setNetworkCategory(
            article_data['networkCategory'] ? article_data['networkCategory']['name']: ""
        );
        this.articlesEdit.setPostPaymentCategory(
            article_data['postPaymentCategory'] ? article_data['postPaymentCategory']['name']: ""
        );
        this.articlesEdit.getTemplateViewModel().newRepublishDate(new Date().toISOString().slice(0, 10));
        this.articlesEdit.setArticleRepublishData(article_data['republishes']);
        this.articlesEdit.setPermalink(article_data['permalink']);
        this.articlesEdit.setIdPublishStatus(article_data['publishStatus']['id']);
        this.articlesEdit.setAmazonsiteArticleTitle(article_data['amazonsiteArticleTitle']);
        this.articlesEdit.getTemplateViewModel().filterDate.singleDatePicker(article_data['dateOriginalPublish']);
        if(article_data['amazonsitePublishDate']){
            this.articlesEdit.getTemplateViewModel().filterDate.singleDatePicker(article_data['amazonsitePublishDate'])
        }

    }

    public cancelForm() {
        this.cancelEditArticle();
    }

    protected cancelEditArticle(){

        // redirect to articles list
        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/');
    }

    protected syncEditArticle(){

        // redirect to articles list
        this.sync();
    }

    protected saveEditArticle(){

        this.save();
    }

    protected getUsersSuggestion(keyword){

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected getWebsiteUsersSuggestion(keyword){
        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/website-users/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetWebsiteUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.users){
                    obj.articlesEdit.setUsers(responseParsed.data.users);
                }
            });

            //obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
    }

    protected onGetWebsiteUsersSuggestionsReturn(req, obj){
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.websiteUsers){
                    obj.articlesEdit.setWebsiteUsers(responseParsed.data.websiteUsers);
                }
            })
        }
    }

    public filterDropdownOnChange(){

    }

    protected filterList(){

        // LOADING : starts
        //this.articlesEdit.activateLoading();

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }
    }

    protected sync() {


        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/article/sync/' + this.articlesEdit.getTemplateViewModel().id();

        let formReq_params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSyncReturn;
        XHRHdl.execute();
    }

    protected save() {

        this.loadingIn(this.articlesEdit.builtTemplate);

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/article/save-old/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {
            idArticle: this.articlesEdit.getTemplateViewModel().id(),
            idPublishStatus: this.articlesEdit.getTemplateViewModel().idPublishStatus(),
            createRepublish: this.articlesEdit.getTemplateViewModel().showNewRepublish(),
            permalink: this.articlesEdit.getTemplateViewModel().permalink(),
            amazonsiteArticleTitle: this.articlesEdit.getTemplateViewModel().amazonsiteArticleTitle(),
            amazonsitePublishDate: this.articlesEdit.getTemplateViewModel().filterDate.singleDatePicker(),
            idDisplayAuthor: this.articlesEdit.getTemplateViewModel().filterDisplay_author.idUser(),
            republishArticle: {
                idAuthor: this.articlesEdit.getTemplateViewModel().filterUser_author.idUser(),
                idSeniorEditor: this.articlesEdit.getTemplateViewModel().filterUser_SrEditor.idUser(),
                idJuniorEditor: this.articlesEdit.getTemplateViewModel().filterUser_JrEditor.idUser(),
                idPostPaymentCategory: this.articlesEdit.getTemplateViewModel().paymentCategoryFilter.selectedOption(),
                amount: this.articlesEdit.getTemplateViewModel().amountAuthor(),
                percentage: this.articlesEdit.getTemplateViewModel().percentageAuthor(),
                percentageEditor: this.articlesEdit.getTemplateViewModel().percentageEditor(),
            }
        }

        //let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj){

        return function (){
            obj.manageResponse(req, obj, function (){

                page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand+ '/articles/');
            });
            obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
    }

    protected onSyncReturn(req, obj){

        return function (){
            obj.manageResponse(req, obj, function (){

                page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand+ '/articles/');
            });
            obj.loadingOut(obj.articlesEdit.builtTemplate);
        }
    }

    protected filterSimpleOnChange() {
        // on keywords filtering, always set the page back to 1.
        //this.viewModel.list.pagination.pageNumber(1);
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }
}




// WEBPACK FOOTER //
// ./js/modules/articles_edit.ts